import { Breadcrumb as IOBreadcrumb, BreadcrumbItem } from '@doda/io-react/pc';
import { useAppSelector } from '@doda/common/src/redux/hooks';
import { breadcrumbDataSelector } from 'redux/features/careerRecommendJobList';

/**
 * 資格経歴スキル一覧画面 パンくずリスト
 */
export const Breadcrumb: React.FC = () => {
  const breadcrumbData = useAppSelector(breadcrumbDataSelector);
  return (
    <IOBreadcrumb>
      {breadcrumbData.map((breadcrumbItem, i) => (
        <BreadcrumbItem
          href={
            i === breadcrumbData.length - 1 ? undefined : breadcrumbItem.href
          }
          key={i}
        >
          {breadcrumbItem.text}
        </BreadcrumbItem>
      ))}
    </IOBreadcrumb>
  );
};
